import React, {useState, useEffect} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {Panel} from "primereact/panel";
import {Button} from 'primereact/button';
import {BlockUI} from "primereact/blockui";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import FormLocker from "../../util/FormLocker";
import axios from "axios";
import Cookies from "js-cookie";

import HelpComponent from "../HelpComponent";
import {Dropdown} from "primereact/dropdown";

const _FM_AccommodationchecklistFormComponent = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id, action} = useParams();
  const [formData, setFormData] = useState({});
  const [checklistTriggers, setChecklistTriggers] = useState([]);
  const [items, setItems] = useState([]);
  const [newItem, setNewItem] = useState('');
  const [loading, setLoading] = useState(false);
  const [locking, setLocking] = useState(false);

  const validate = (data) => {
    let errors = {};
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if (formData && formData.id) {
      axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST
        + "accommodation-readiness-checklist/" + formData.id,
        {
          ...formData,
          items: items,
        },
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          setFormData(response.data.data);
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderAccommodationchecklistList: true,
          })
          if (props.closeForm === true) {
            navigate(-1)
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    } else {
      axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "accommodation-readiness-checklist",
        {
          ...formData,
          items: items,
        },
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          setFormData(response.data.data)
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderAccommodationchecklistList: true,
          })
          if (props.closeForm === true) {
            navigate(-1)
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    }
    form.restart();
  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  FormLocker(() => {
    if (formData && formData.id && formData._class_name) {
      window.App.formLock(formData._class_name, formData.id)
    }
  }, 1000);

  useEffect(() => {
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "dictionary/readiness-checklist-trigger",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setChecklistTriggers(response.data.data)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    if (id) {
      setLoading(true)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "accommodation-readiness-checklist/" + id,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setLoading(false)
          setFormData(response.data.data);
          setItems(response.data.data.items)
          if (response.data && response.data.data && response.data.data.under_edit_from
            && response.data.data.under_edit_by !== Number(Cookies.get('userId'))) {
            setLocking(true)
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
    window.App.setState({rerenderAccommodationchecklistForm: false})
  }, [window.App.state.rerenderAccommodationchecklistForm === true])

  return (
    <>
      <BlockUI blocked={locking} className="blocked-ui-overlay" template={<div className="blocked-ui-message"><i className="pi pi-exclamation-triangle blocked-ui-message-icon" aria-hidden="true"></i>{t("module_editing_after_save_only")}</div>}>
        <Form onSubmit={onSubmit} initialValues={formData}
              validate={validate} render={({handleSubmit}) => (
          <form onSubmit={handleSubmit} className="">
            <Panel className={"p-mt-3"}>
              <div className={"p-grid"}>
                <div className={"p-col"}>
                  <h2 className={"p-m-0"}>{t('accommodationchecklist_form')}</h2>
                </div>
                <div className={"p-col p-text-right p-col-align-center"}>
                  <Button type="submit" aria-label={t('save')} icon={"pi pi-save"}
                          loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: false}
                          }}
                          className="p-button-success p-ml-2"/>
                  <Button type="submit" aria-label={t('save_and_close')}
                          loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: true}
                          }}
                          className="p-button-success p-ml-2">
              <span>
                <i className={"pi pi-save"}></i>&nbsp;&nbsp;<i className={"pi pi-backward"}></i>
              </span>
                  </Button>
                  <Button type="button"
                          icon={"pi pi-times"}
                          onClick={() => {
                            navigate(-1)
                          }}
                          className="p-button-secondary close p-ml-2"/>
                </div>
              </div>
              {/*<HelpComponent type={"site"} position={"IN_ACTIVE_BOX"}/>*/}
              <HelpComponent type={"edit_box"}/>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6"}>
                  <Field name="name" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"name"}/>
                      <label htmlFor="name"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('name')}</label>
                      <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-6"}>
                  <Field name="checklist_trigger" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"checklist_trigger"}/>
                      <label htmlFor="checklist_trigger"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('checklist_trigger')}</label>
                      <span className="p-d-block">
                        <Dropdown  options={checklistTriggers}
                                  optionLabel="key"
                                  optionValue="value"
                                  id={"checklist_trigger"}
                                  emptyMessage={t('empty_message')}
                                  onChange={(e) => {
                                    setFormData({
                                      ...formData,
                                      checklist_trigger: e.value
                                    })
                                  }}
                                  value={formData?.checklist_trigger?.id || formData?.checklist_trigger}
                                  showClear
                        />
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-6"}>
                  <div className="p-field p-fluid">
                    <HelpComponent type={"field"} field={"items"}/>
                    <label htmlFor="items">{t('items')}</label>
                    <span className="p-d-block">
                    {items && items[0] &&
                      <>
                        {items.map((item, index) => {
                          return (
                            <div className={"p-grid"} key={index}>
                              <div className={"p-col-10 p-col-align-center"} key={index}>
                                <i className={"pi pi-circle"} style={{position: 'relative', bottom: '-1px'}}></i>
                                &nbsp;
                                {item}
                              </div>
                              <div className={"p-col-2 p-col-align-center p-text-right"}>
                                <Button icon="pi pi-trash" className="p-button-sm p-button-danger"
                                        tooltip={t('delete')}
                                        type={"button"}
                                        tooltipOptions={{position: 'left'}}
                                        onClick={() => {
                                          let updatedItems = [...items];
                                          updatedItems.splice(index, 1);
                                          setItems(updatedItems);
                                        }}
                                />
                              </div>
                            </div>
                          )
                        })}
                      </>
                    }
                      <span className={"p-inputgroup"}>
                        <InputText className={""}
                                   onChange={(e) => {
                                     setNewItem(e.target.value)
                                   }}
                                   value={newItem}
                        />
                        <Button icon="pi pi-plus" className="p-button-success w-100"
                                type="button"
                                disabled={!newItem}
                                tooltip={t('add')}
                                tooltipOptions={{position: 'left'}}
                                onClick={() => {
                                  let _items = items
                                  _items.push(newItem)
                                  setItems(_items)
                                  setNewItem('')
                                }}
                        />
                        </span>
                    </span>
                  </div>
                </div>
              </div>
            </Panel>
          </form>
        )}/>
      </BlockUI>
      {locking === true &&
        <div className={"p-mt-2"}>
          <i className={"pi pi-exclamation-circle"}></i>
          &nbsp;
          {t('form_under_edit')}
          {formData && formData.under_edit_by_name_snap &&
            <>&nbsp;{t('form_under_edit_by')}: {formData.under_edit_by_name_snap}</>
          }
        </div>
      }
    </>
  )
}
export default withTranslation('common')(_FM_AccommodationchecklistFormComponent);
